import { render, staticRenderFns } from "./Finance.vue?vue&type=template&id=0b0d8b88&scoped=true&"
import script from "./Finance.vue?vue&type=script&lang=js&"
export * from "./Finance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0d8b88",
  null
  
)

export default component.exports